export const updateLocalStorage = (userData) => {
  const { token, user } = JSON.parse(localStorage.getItem("auth"));

  if (!token || !user) return;

  try {
    const updatedUser = {
      ...user,
      ...userData,
    };

    localStorage.setItem("auth", JSON.stringify({ token, user: updatedUser }));
  } catch (error) {
    console.error("🚀 -> updateUserFields -> error:", error);
  }
};
